// src/components/MetaTagsUpdater.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Define metadata for different routes
const metaData = {
  "/": {
    title: "THE PHYT GYM | Coach HT - Fun & Effective Fitness Training",
    description: "THE PHYT GYM - Coach HT makes working out fun and effective. Get to your health and fitness goals twice as fast using the PHYT method focused on proper form and alignment.",
    ogTitle: "THE PHYT GYM – Coach HT | Fun & Effective Fitness Training",
    ogDescription: "Coach HT makes working out fun and effective. Get to your health and fitness goals twice as fast using the PHYT method focused on proper form and alignment.",
    keywords: "THE PHYT GYM, Coach HT, Heather, personal training, fitness coaching, weight loss, strength training, PHYT method, form and alignment, nutrition coaching, Los Angeles, NASM certified, ballet trained",
    ogUrl: "https://thephytgym.com"
  },
  "/about": {
    title: "About Coach HT | THE PHYT GYM",
    description: "Learn about Coach HT (Heather), founder of THE PHYT GYM. Former bikini competitor, NASM certified trainer, and creator of the PHYT method for effective fitness training.",
    ogTitle: "About Coach HT – Founder of THE PHYT GYM",
    ogDescription: "Meet Coach HT, a former bikini competitor, NASM certified trainer, and founder of THE PHYT GYM with expertise in the PHYT method for effective fitness training.",
    keywords: "Coach HT, Heather, THE PHYT GYM founder, personal trainer, NASM certified, bikini competitor, PHYT method, fitness expert, Los Angeles trainer",
    ogUrl: "https://thephytgym.com/about"
  },
  "/services": {
    title: "Services | Personal Training & Nutrition Coaching | THE PHYT GYM",
    description: "Discover our comprehensive fitness and nutrition coaching services. From personal training to nutrition guidance, Coach HT provides customized programs for all fitness levels.",
    ogTitle: "Fitness & Nutrition Coaching Services – THE PHYT GYM",
    ogDescription: "Get personalized workout plans, nutrition coaching, and comprehensive fitness guidance with Coach HT's proven PHYT method.",
    keywords: "personal training, nutrition coaching, fitness programs, workout plans, PHYT method, Coach HT training, Los Angeles fitness, strength training",
    ogUrl: "https://thephytgym.com/services"
  },
  "/results": {
    title: "Success Stories | Real Client Transformations | THE PHYT GYM",
    description: "See real client transformations and success stories. Our clients have achieved incredible results with Coach HT's PHYT method and personalized coaching approach.",
    ogTitle: "Real Client Transformations – THE PHYT GYM Success Stories",
    ogDescription: "Browse our gallery of real client transformations and read their testimonials about working with Coach HT and the PHYT method.",
    keywords: "fitness transformations, weight loss success stories, client testimonials, before and after, body transformation, fitness results, THE PHYT GYM reviews, Coach HT results",
    ogUrl: "https://thephytgym.com/results"
  },
  "/packages": {
    title: "Membership Packages | THE PHYT GYM",
    description: "Explore our range of membership packages designed for every fitness level and goal. From small group training to premium coaching, find the perfect plan for your journey.",
    ogTitle: "Membership Packages – Find Your Perfect Fitness Plan",
    ogDescription: "Choose from our range of fitness packages including small group training, personal coaching, and the PHYT Travel Kit for your fitness journey.",
    keywords: "fitness membership, personal training packages, small group training, PHYT Travel Kit, fitness programs, Coach HT packages, Los Angeles fitness",
    ogUrl: "https://thephytgym.com/packages"
  },
  "/blog": {
    title: "Fitness Blog | Tips & Insights | THE PHYT GYM",
    description: "Read the latest fitness tips, nutrition advice, and insights from Coach HT. Stay motivated and informed on your fitness journey with THE PHYT GYM blog.",
    ogTitle: "Fitness Blog – Tips & Insights from Coach HT",
    ogDescription: "Get expert fitness advice, nutrition tips, and motivation from Coach HT and THE PHYT GYM team to support your fitness journey.",
    keywords: "fitness blog, nutrition tips, workout advice, fitness motivation, Coach HT blog, THE PHYT GYM articles, fitness education",
    ogUrl: "https://thephytgym.com/blog"
  },
  "/faq": {
    title: "Frequently Asked Questions | THE PHYT GYM",
    description: "Find answers to common questions about THE PHYT GYM services, Coach HT's training methods, and how to get started on your fitness journey.",
    ogTitle: "FAQ – Frequently Asked Questions | THE PHYT GYM",
    ogDescription: "Get answers to common questions about our fitness programs, training methods, and how to begin your transformation with Coach HT.",
    keywords: "fitness FAQ, THE PHYT GYM questions, Coach HT FAQ, fitness program questions, training information",
    ogUrl: "https://thephytgym.com/faq"
  },
  "/contact": {
    title: "Contact Us | Get Started with THE PHYT GYM",
    description: "Ready to transform your fitness journey? Contact THE PHYT GYM today to schedule a consultation with Coach HT and start your transformation.",
    ogTitle: "Contact THE PHYT GYM – Start Your Transformation Today",
    ogDescription: "Reach out to Coach HT and THE PHYT GYM team to learn more about our fitness coaching services or to schedule your consultation.",
    keywords: "contact THE PHYT GYM, Coach HT contact, fitness consultation, personal trainer contact, Los Angeles fitness coaching",
    ogUrl: "https://thephytgym.com/contact"
  },
  "/privacy-policy": {
    title: "Privacy Policy | THE PHYT GYM",
    description: "Learn about how THE PHYT GYM collects, uses, and protects your personal information.",
    ogTitle: "Privacy Policy | THE PHYT GYM",
    ogDescription: "Learn more about how THE PHYT GYM collects, uses, and protects your personal information.",
    keywords: "privacy policy, data protection, user privacy, THE PHYT GYM privacy",
    ogUrl: "https://thephytgym.com/privacy-policy"
  },
  "/terms": {
    title: "Terms & Conditions | THE PHYT GYM",
    description: "Read the terms and conditions for using THE PHYT GYM services and website.",
    ogTitle: "Terms & Conditions | THE PHYT GYM",
    ogDescription: "Review our terms and conditions for using THE PHYT GYM services and website.",
    keywords: "terms and conditions, legal terms, service terms, THE PHYT GYM terms",
    ogUrl: "https://thephytgym.com/terms"
  }
};

function MetaTagsUpdater() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    
    // Get metadata for current route (default to homepage if route not found)
    const currentMeta = metaData[path] || metaData["/"];
    
    // Update document title
    document.title = currentMeta.title;
    
    // Update meta tags
    const metaTags = {
      description: document.querySelector('meta[name="description"]'),
      keywords: document.querySelector('meta[name="keywords"]'),
      ogTitle: document.querySelector('meta[property="og:title"]'),
      ogDescription: document.querySelector('meta[property="og:description"]'),
      ogUrl: document.querySelector('meta[property="og:url"]'),
      twitterTitle: document.querySelector('meta[name="twitter:title"]'),
      twitterDescription: document.querySelector('meta[name="twitter:description"]')
    };
    
    // Update each meta tag if it exists
    if (metaTags.description) metaTags.description.setAttribute("content", currentMeta.description);
    if (metaTags.keywords) metaTags.keywords.setAttribute("content", currentMeta.keywords);
    if (metaTags.ogTitle) metaTags.ogTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.ogDescription) metaTags.ogDescription.setAttribute("content", currentMeta.ogDescription);
    if (metaTags.ogUrl) metaTags.ogUrl.setAttribute("content", currentMeta.ogUrl);
    if (metaTags.twitterTitle) metaTags.twitterTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.twitterDescription) metaTags.twitterDescription.setAttribute("content", currentMeta.ogDescription);
    
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
}

export default MetaTagsUpdater;